import * as React from 'react'

import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { useTheme } from '@material-ui/core'

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
    headCells,
  } = props

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }
  const theme = useTheme();
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) =>
          headCell?.activeIndexOnly ? (true && (
            <TableCell
              width={headCell.width}
              key={index}
              align={headCell.align}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sx={{ background: theme.palette.thead, color: theme.palette.listItem }}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                disabled={!headCell.sortable}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                sx={{
                  '&.Mui-active': {
                    color: theme.palette.listItem, // Change this to your desired active color
                  },
                  '& .MuiTableSortLabel-icon': {
                    color: theme.palette.listItem, // Icon color
                  }

                }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box sx={visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          )
          ) : (
            <TableCell
              key={index}
              align={headCell.align}
              sx={{ background: theme.palette.thead, color: theme.palette.listItem }}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                disabled={!headCell.sortable}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                sx={{
                  '&.Mui-active': {
                    color: theme.palette.listItem, // Change this to your desired active color
                  },
                  '& .MuiTableSortLabel-icon': {
                    color: theme.palette.listItem, // Icon color
                  }

                }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ),
        )}
      </TableRow>
    </TableHead>
  )
}

export default EnhancedTableHead
